import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import {SplitText} from "gsap/SplitText";

gsap.registerPlugin(ScrollTrigger, SplitText);
const isMobileFirstLoad = window.innerWidth < 768;



const callBackCardAnimationTeaser = (className) => {
    const cardsPhoto = document.querySelectorAll(className);

    cardsPhoto.forEach((card) => {
        const tlCard = gsap.timeline({
            paused: true,
            ease: 'power1.in',
            smoothChildTiming: true
        });

        tlCard.to(
            card.querySelectorAll('.block-reveal *'),
            {
                translateY: '-100%',
                duration: 0.25,
                onComplete: () => {
                    gsap.set(card.querySelectorAll('.hover-reveal'), {
                        display: 'inline-block'
                    });
                    gsap.set(card.querySelectorAll('.block-reveal *'), {
                        translateY: '100%'
                    });
                }
            },
            '<'
        );

        tlCard.to(
            card.querySelectorAll('.block-reveal *'),
            {
                translateY: '0%',
                duration: 0.25,
                onReverseComplete: () => {
                    gsap.set(card.querySelectorAll('.hover-reveal'), {
                        display: 'none'
                    });
                }
            },
            '>'
        );

        tlCard.to(
            card.querySelectorAll('.hover-reveal *'),
            {
                translateY: '0%',
                duration: 0.25
            },
            '<'
        );

        card.addEventListener('mouseenter', () => {
            tlCard.play();
            console.log('play')
        });
        card.addEventListener('mouseleave', () => {
            tlCard.reverse();
            console.log('reverse')
        });

        // if the cursor is currently on the card, play the animation (because the user can be on the card and the event mouse enter will not be triggered)
        if (card.matches(':hover')) {
            tlCard.play();
        }
    });
};


if (!isMobileFirstLoad) {
    //const cardsPlugAndSaveTeaser = document.querySelectorAll(".mksun-plug-and-save--teaser .mksun-plug-and-save__slider__ctn__slide")
    callBackCardAnimationTeaser(".mksun-plug-and-save--teaser .mksun-plug-and-save__slider__ctn__slide")

} else {
    callBackCardAnimationTeaser('.mksun-plug-and-save--teaser .mksun-plug-and-save__slider__ctn__slide');
}